// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"f028ce5cfe799caf","5405":"d7c93d4c391515e0"}[chunkId] + ".css";
};